var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conteudo"},[_c('flCabecalhoForm',{attrs:{"msg":_vm._traducao('global', 'obrigatorio'),"cls":"print-titulo-form-20","texto":'Endereço Residencial'}}),_vm._v(" "),_c('fl-endereco',{ref:"endereco_residencial",attrs:{"tipo":"residencial"},on:{"dados-endereco-residencial":(item) => {
				_vm.form.dados_endereco_residencial = item
			}}}),_vm._v(" "),_c('flCabecalhoForm',{attrs:{"msg":_vm._traducao('global', 'obrigatorio'),"cls":"print-titulo-form-20","texto":'Endereço Funcional'}}),_vm._v(" "),_c('fl-endereco',{ref:"endereco_funcional",attrs:{"tipo":"funcional"},on:{"dados-endereco-funcional":(item) => {
				_vm.form.dados_endereco_funcional = item
			}}}),_vm._v(" "),_c('fl-dados-adicionais',{ref:"dados_adicionais",attrs:{"postos":_vm.postos,"cargos":_vm.cargos,"menu":_vm.menu},on:{"dados-adicionais":(obj) => {
				;(_vm.form.dados_adicionais = obj.form),
					(_vm.form.dados_emergencia = obj.dados),
					(_vm.form.dados_contato_emergencial = obj.contato),
					(_vm.form.dados_endereco_emergencial = obj.endereco),
					(_vm.form.tipo = obj.tipo)
			}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }